export default {
  sections: {
    order_summary: 'Ordretotal',
  },
  labels: {
    add_items: 'Tilføj varer for at komme i gang',
    item_count_one: '{{count}} vare',
    item_count_other: '{{count}} varer',
  },
  buttons: {
    return: 'Tilbage til ordregennemgang',
  },
};
